import React, { useEffect, useRef, useState } from "react";
import { Menu } from "lucide-react";
import "../Navbar/Navbar.css";
import NT from "../../Images/Resume Builder.svg";
import { logout } from "../../Api/apiService";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../Redux/Authentication/AuthenticationAction";
import { toast } from "react-toastify";
import CustomizeButton from "../Button/Customize-Button";
import CustomPopover from "../CustomPopover/Custom-popover";
import hamburger from "../../Images/icons/hamburger-icon.svg";
import { Button } from "antd";
import ProfileModal from "./components/Profile-Modal";

function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [open, setOpen] = useState(false);
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth);
  const { name } = user;

  const getInitials = (name) => {
    if (!name) return "";
    const nameParts = name.split(" ");
    const initials = nameParts[0][0];
    return initials.toUpperCase();
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const handleLogout = () => {
    toast.success("Logged out successfully.", {
      autoClose: 2000,
    });
    setTimeout(() => {
      logout();
      dispatch(logoutUser());
      navigate("/");
      window.location.reload();
    }, 3000);
  };


   const handleOpenProfile = () => {
    setIsProfileModalOpen(true);
  };

  const handleCloseProfile = () => {
    setIsProfileModalOpen(false);
  };

  

  const popoverContent = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Button
       onClick={handleOpenProfile}
        // your onClick function
        className="navbar-item"
      >
        <span>Profile</span>
        <img src={hamburger} alt="menu" />
      </Button>
      <CustomizeButton
        style={{
          width: "11rem",
        }}
        variant="outlined"
        onClick={handleLogout}
      >
        Logout
      </CustomizeButton>
    </div>
  );

  return (
    <header className="navbar" ref={dropdownRef}>
      <div className="navbar-container">
        <div className="navbar-logo">
          {user.role === "ROLE_HR" ? (
            <a href="/dashboardHr">
              <img src={NT} alt="Logo" />
            </a>
          ) : (
            <a href="/dashboard">
              <img src={NT} alt="Logo" />
            </a>
          )}
        </div>
        <div>
          <CustomPopover
            style={{
              width: "200px",
            }}
            content={popoverContent}
            placement="bottomRight"
            trigger="click"
          >
            <Menu
              style={{
                color: "white",
                cursor: "pointer",
                fontSize: "24px",
              }}
            />
          </CustomPopover>
        </div>
      </div>
       <ProfileModal
        
        visible={isProfileModalOpen}
        onClose={handleCloseProfile}
      />
    </header>
    
  );
}

export default Navbar;
